/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { LayoutDashboard } from 'lucide-react';

interface DisplaySettingsSectionProps {
  showDashboard: boolean;
  onChange: (showDashboard: boolean) => void;
  onDirty: () => void;
}

export function DisplaySettingsSection({ 
  showDashboard, 
  onChange, 
  onDirty 
}: DisplaySettingsSectionProps) {
  return (
    <div style={{ 
      marginBottom: '32px',
      padding: '20px',
      background: '#f9f9f9',
      borderRadius: '8px',
      border: '1px solid #ddd'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <LayoutDashboard size={20} style={{ marginRight: '8px', color: '#0066cc' }} />
        <h3 style={{ margin: 0 }}>Display Settings</h3>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={showDashboard}
            onChange={(e) => {
              onChange(e.target.checked);
              onDirty();
            }}
          />
          <span style={{ fontSize: '14px' }}>Show Dashboard in navigation</span>
        </label>
        <small style={{ color: '#666', fontSize: '12px', marginLeft: '24px' }}>
          When enabled, the Dashboard link will appear in the sidebar navigation. When disabled, the app will open directly to the Products page.
        </small>
      </div>
    </div>
  );
}
